export const enum  TabsReservationEnum {
  EdiFileHistory = 8
}



// WEBPACK FOOTER //
// ./src/app/core/enums/tabs-reservation.enum.ts